import React from "react";
import { SectionHeading } from "../ui";
import { RevealGroup, RevealItem, RevealStagger } from "../motion/Reveal";
import { PUBLIC_MOTION } from "../motion/publicMotion";

const steps = [
  {
    number: "01",
    title: "Ansök för gruppen",
    description:
      "Gruppledaren registrerar laget eller klassen. Ansökan behöver godkännas innan gruppen går vidare.",
  },
  {
    number: "02",
    title: "Slutför onboarding",
    description:
      "Efter godkännande kompletterar gruppledaren gruppens uppgifter och bjuder in säljarna.",
  },
  {
    number: "03",
    title: "Dela personliga länkar",
    description:
      "Säljarna delar egna länkar och QR-koder. Kunden beställer i shoppen och ser tillgängliga betalningsval.",
  },
  {
    number: "04",
    title: "Leverera och avsluta",
    description:
      "Ordern levereras direkt eller via gruppen. Efter avslut, leverans och väntetid kan förtjänsten betalas ut.",
  },
];

export function HowItWorksSection({ id = "process" }) {
  return (
    <section id={id} className="bg-white py-20">
      <RevealGroup className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <RevealItem tone="text">
          <SectionHeading
            eyebrow="Så fungerar SalesPartner"
            title="Fyra delar från ansökan till utbetalning"
            align="center"
          />
        </RevealItem>
        <RevealItem tone="text">
          <p className="mx-auto max-w-2xl text-center text-neutral-600 text-base md:text-lg">
            Gruppen godkänns först. Därefter följer onboarding, försäljning, leverans och kampanjavslut.
          </p>
        </RevealItem>
        <RevealStagger className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4" stagger={PUBLIC_MOTION.staggerCard}>
          {steps.map((step) => (
            <RevealItem key={step.number} tone="card">
              <div className="group rounded-3xl border border-neutral-200 bg-white p-8 text-center shadow-soft transition duration-200 hover:border-primary-200 hover:shadow-colored-primary motion-safe:hover:-translate-y-0.5">
                <div className="mx-auto mb-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-primary-500 to-primary-600 text-lg font-bold text-white shadow-colored-primary">
                  {step.number}
                </div>
                <h3 className="mb-3 text-xl font-bold text-neutral-900 transition-colors group-hover:text-primary-600">
                  {step.title}
                </h3>
                <p className="text-sm leading-relaxed text-neutral-600 md:text-base">{step.description}</p>
              </div>
            </RevealItem>
          ))}
        </RevealStagger>
      </RevealGroup>
    </section>
  );
}
